import { jsx as _jsx } from "react/jsx-runtime";
const Plus = props => (_jsx("svg", { width: "13", height: "13", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M6.5 0a.855.855 0 00-.855.855v4.79H.855a.855.855 0 100 1.71h4.79v4.79a.855.855 0 101.71 0v-4.79h4.79a.855.855 0 100-1.71h-4.79V.855A.855.855 0 006.5 0z", fillRule: "nonzero" }) }));
export default Plus;
